/**
 * ネームスペース取得
 */
const getNameSpace = (str) => 
{
  const arr = str.split('.');
  let index = 0;
  let ns = window;
  do{
    // console.log('============key:' + arr[index]);
    // console.log(ns);
    ns = addSpace(ns, arr[index]);
  }while(++index < arr.length);

  return ns;
}

const addSpace = (ns, key) =>{
  if(!ns[key]) ns[key] = new Object();
  return ns[key];
}


const NameSpace = {
  getNameSpace:getNameSpace
}

export default NameSpace